import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInboxChecked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconInboxChecked"><Path fillRule="evenodd" clipRule="evenodd" d="M18.7923 4.0531L11.0283 15.4289L6.18941 10.4752L7.26243 9.42701L10.8217 13.0707L17.5533 3.20752L18.7923 4.0531ZM4.5 13.9998V19.4998H19.5V13.9998H21V20.9998H3V13.9998H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInboxChecked;
